module.exports = __webpack_public_path__ + "fff0c27ad324fe4db5e89219f63e3ef4.png";